import type { BlockPartnersLocation } from 'types/block-partners-location';
import React from 'react';
import Image from 'next/image';
import { Wrap } from '@leafwell/components';
import LocationBusinessJson from 'components/structured-data/location-business';
import HeadingBody from './heading-body';

const PartnersLocation: React.FC<BlockPartnersLocation> = ({
  title,
  partners,
  image,
}) => {
  const hasImage = image !== null;

  return (
    <>
      <Wrap className="gap-y-4">
        <header className="pb-10 border-b border-solid border-gray-200">
          {title?.length > 0 && (
            <HeadingBody className="font-semibold" level="2" title={title} />
          )}
        </header>
        <div
          className={[
            'grid gap-x-3 gap-y-5',
            hasImage ? 'md:grid-cols-2' : 'md:grid-cols-1',
          ].join(' ')}
        >
          {hasImage ? (
            <Image
              src={image.src}
              alt={image.alt}
              width={image.width}
              height={image.height}
              sizes="(max-width: 1023px) 100vw, 50vw"
              className="w-full max-w-xl mx-auto"
            />
          ) : null}
          {partners.length ? (
            <ul
              className={[
                'grid grid-cols-1 md:grid-cols-2 gap-y-10 gap-x-12',
                hasImage ? '' : 'lg:grid-cols-3',
              ].join(' ')}
            >
              {partners.map((partner, index) => {
                const { formattedAddress, internationalPhoneNumber, link } =
                  partner;

                return (
                  <li
                    key={`partner-${index}`}
                    className="col-span-1 flex flex-col gap-y-2"
                  >
                    <a
                      href={link}
                      className="text-sm lg:text-base flex items-center hover:text-lilac-500"
                    >
                      <Image
                        className="inline mr-1.5"
                        src="/location.svg"
                        alt=""
                        width={16}
                        height={16}
                      />
                      {formattedAddress}
                    </a>
                    <p className="text-sm lg:text-base flex items-center">
                      <Image
                        className="inline mr-1.5"
                        src="/mobile.svg"
                        alt=""
                        width={16}
                        height={16}
                      />
                      {internationalPhoneNumber}
                    </p>
                  </li>
                );
              })}
            </ul>
          ) : null}
        </div>
      </Wrap>
      {/*       <LocationBusinessJson partners={partners} />
       */}{' '}
    </>
  );
};

export default PartnersLocation;
